var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewInsightsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5H6.66667C5.74619 5.5 5 6.24619 5 7.16667V18.8333C5 19.7538 5.74619 20.5 6.66667 20.5H15C15.9205 20.5 16.6667 19.7538 16.6667 18.8333V7.16667C16.6667 6.24619 15.9205 5.5 15 5.5Z",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 5.5H24.9997C24.0792 5.5 23.333 6.24619 23.333 7.16667V12.1667C23.333 13.0871 24.0792 13.8333 24.9997 13.8333H33.333C34.2535 13.8333 34.9997 13.0871 34.9997 12.1667V7.16667C34.9997 6.24619 34.2535 5.5 33.333 5.5Z",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 20.5H24.9997C24.0792 20.5 23.333 21.2462 23.333 22.1667V33.8333C23.333 34.7538 24.0792 35.5 24.9997 35.5H33.333C34.2535 35.5 34.9997 34.7538 34.9997 33.8333V22.1667C34.9997 21.2462 34.2535 20.5 33.333 20.5Z",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27.166H6.66667C5.74619 27.166 5 27.9122 5 28.8327V33.8327C5 34.7532 5.74619 35.4993 6.66667 35.4993H15C15.9205 35.4993 16.6667 34.7532 16.6667 33.8327V28.8327C16.6667 27.9122 15.9205 27.166 15 27.166Z",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewInsightsIcon);
export default __webpack_public_path__ + "static/media/ReviewInsightsIcon.5fe7ab2a27d72218f37ed9ae39fe551f.svg";
export { ForwardRef as ReactComponent };